import styled from '@emotion/styled';
import { ThemeProps, SelectableThemeProps } from '@theme/base';
import { mq } from '@styles/breakpoints';
import { useI18NextContext } from '@components/hooks';
import { TestId } from '@components/test-ids';
import { getHTML } from '@util/common';

const Container = styled.div(({ theme }: ThemeProps) => ({
  alignItems: 'center',
  columnGap: theme.custom.spacing.medium,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  paddingLeft: theme.custom.spacing.medium,
  paddingRight: theme.custom.spacing.medium,
  p: {
    fontSize: '1.5rem'
  },
  ['> div']: {
    textAlign: 'center'
  },
  [mq.small]: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    p: {
      minWidth: 150
    }
  }
}));

const Pill: any = styled.div(({ theme, isSelected }: SelectableThemeProps) => ({
  cursor: 'pointer',
  display: 'inline-block',
  fontSize: '1.5rem',
  padding: `${theme.custom.spacing.medium / 4}px ${theme.custom.spacing.medium / 2}px`,
  marginBottom: theme.custom.spacing.small,
  minHeight: 22,
  borderRadius: 24,
  textAlign: 'left',
  border: `2px solid ${isSelected ? theme.custom.states.selected.dark : theme.custom.colors.group10.light}`,
  backgroundColor: isSelected ? theme.custom.colors.group1.lighter : theme.custom.colors.white,
  marginRight: theme.custom.spacing.small,

  ['&:last-of-type']: {
    marginRight: 0
  }
}));

const FLEXIBLE_DATES = [0, 1, 2, 3, 7];

interface FlexibleDatesProps {
  flexibleDays: number;
  onFlexibleDaysChange: (value: number) => void;
}

export const FlexibleDates = ({ flexibleDays, onFlexibleDaysChange }: FlexibleDatesProps) => {
  const t: any = useI18NextContext();
  const handleChange = (value: number) => {
    onFlexibleDaysChange(value);
  };

  return (
    <Container data-testid={TestId.dealFinder.flexibleNights}>
      <p>{t('form__field-label--flexible-dates')}</p>
      <div>
        {FLEXIBLE_DATES.map((count) => (
          <Pill
            key={count}
            isSelected={flexibleDays === count}
            onClick={() => handleChange(count)}
            dangerouslySetInnerHTML={getHTML(
              count === 0
                ? t('common__label--exact-dates')
                : `&plusmn;${count} ${t(count > 1 ? 'common__label--days' : 'common__label--day').toLowerCase()}`
            )}
          />
        ))}
      </div>
    </Container>
  );
};
